<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		<form-label 
		v-if="label" 
		:for="id" >
			{{label}}
		</form-label>

		<textarea-autosize
		ref="textarea"  
		:id="id" 
		:value="val" 
		:minHeight="70"
		v-bind="$attrs" 
		@input="input"
		class="form-control" 
		:class="{
			'is-invalid': $hasErrors(errors), 
			'w-100': !label,
			'border-0': !border,
		}" />
		
		<form-errors v-bind="{errors}" />
	    
	</div>
</template>

<script>

	import { mapState } from 'vuex'

	export default {
		props: {
			id: {
				type: String,
				default() {
					return `input-textarea-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			type: {
				type: String,
				default: 'text',
			},

			errors: {
  				type: String,
 				default: "",
  			},

			border: {
				type: Boolean,
				default: true
			},

			value: [String, Number, Object],
			label: String,
			sublabel: String,
		},

		computed: {

			val() {
				return this.value
			}

		},

		methods: {

			input(value) {
				this.$emit('input', value)

				setTimeout(() => {
					this.$refs.textarea.resize()
				}, 10)
			},
		}, 

		mounted() {

			window.addEventListener("resize", () => {
				if(!this.$refs.textarea)
					return;
				
				this.$refs.textarea.resize()
			})

		}
	}

</script>